<template>
  <div>
    <el-dialog v-if="modal" :visible.sync="modal"  title="图片裁剪" :loading="true" :fullscreen="true" :mask-closable="false" ref="tablemodal">
      <div class="cropper_content">
        <div class="cropper_box">
          <div class="cropper_styl">
            <vue-cropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.outputSize"
              :outputType="option.outputType"
              :info="option.info"
              :canScale="option.canScale"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
              :full="option.full"
              :fixedBox="option.fixedBox"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :centerBox="option.centerBox"
              :height="option.height"
              :infoTrue="option.infoTrue"
              :maxImgSize="option.maxImgSize"
              :enlarge="option.enlarge"
              :mode="option.mode"
              @realTime="realTime"
              @imgLoad="imgLoad"
            ></vue-cropper>
          </div>
          <div class="scope_btn">
            <label class="up_btn" for="uploads">上传图片</label>
            <input
              type="file"
              id="uploads"
              style="position: absolute; clip: rect(0 0 0 0)"
              accept="image/png, image/jpeg, image/gif, image/jpg"
              @change="selectImgFun($event)"
            />
            <el-button type="primary" @click="changeScale(1)">放大</el-button>
            <el-button type="primary" @click="changeScale(-1)">缩小</el-button>
            <el-button type="primary" @click="rotateLeft()">↺ 左旋转</el-button>
            <el-button type="primary" @click="rotateRight()">↻ 右旋转</el-button>
          </div>
        </div>
        <div class="handle_cropper" v-if="previews.url">
          <div class="show_preview">
            <div class="preview" :style="previews.div">
              <img :src="previews.url" :style="previews.img" />
            </div>
            <!-- <div class="preview">
                <img :src="url1" style="max-width: 100%;width: auto;max-height: 400px;" />
            </div> -->
          </div>
          <div class="upload_btn" style="color: #409eff;">
            效果预览
          </div>
        </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="modal = false">取 消</el-button>
            <el-button type="primary" :loading="buttonLoading" @click="submitFun">保存</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
// import ApiFun from "@api/basicarchives/customerManagement.js";
import { VueCropper } from "vue-cropper";
import { getCookieForRoleTag} from "@/common/ulit";
export default {
  name: "Cropper",
  components: {
    VueCropper
  },
  props: {
    isShow:{ //弹窗显示,隐藏
        type: Boolean,
        default: false
    },
    isFixed: {
      type: Boolean,
      default: false
    }, // 是否开启截图框宽高固定比例
    autoCropWidth: {
      type: Number,
      default: 200
    }, // 默认生成截图框宽度
    autoCropHeight: {
      type: Number,
      default: 200
    }, // 默认生成截图框高度
    fixedNumber: {
      type: Array,
      default: () => [1, 1]
    }, // 截图框的宽高比例
    initialImg: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      buttonLoading: false,
      modal: this.isShow,
      previews: {},
      option: {
        img: this.initialImg, // 裁剪图片的地址
        outputSize: 1, // 裁剪生成图片的质量(可选0.1 - 1)
        outputType: "png", // 裁剪生成图片的格式（jpeg || png || webp）
        info: true, // 图片大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: this.autoCropWidth, // 默认生成截图框宽度
        autoCropHeight: this.autoCropHeight, // 默认生成截图框高度
        fixed: this.isFixed, // 是否开启截图框宽高固定比例
        fixedNumber: this.fixedNumber, // 截图框的宽高比例
        full: false, // false按原比例裁切图片，不失真
        fixedBox: false, // 固定截图框大小，不允许改变
        canMove: true, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        height: true, // 是否按照设备的dpr 输出等比例图片
        infoTrue: true, // true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000, // 限制图片最大宽度和高度
        enlarge: 1 ,// 图片根据截图框输出比例倍数
        url1:""
      }
    };
  },
  created() {
      // this.getBase64(this.initialImg, base64 => {
      //     this.option.img = base64;
      //   console.log(base64); // 打印出图片的Base64编码
      // });
  },
  methods: {
    // 初始化函数
    imgLoad(msg) {
      console.log("工具初始化函数=====" + msg);
    },
    // 图片缩放
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    // 向左旋转
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    // 向右旋转
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    // 实时预览函数
    realTime(data) {
      this.previews = data;
      // console.log("datadata", data);
      // 获取截图的blob数据
      // this.$refs.cropper.getCropBlob(blob => {
      //   this.blobToDataURI(blob, (result)=> {
      //       // 这里面写对应的方法
      //       // result是转换后的数据
      //       this.url1 = result
      //   });
      // });

    },
    // 选择图片
    selectImgFun(eve) {
      const file = eve.target.files[0];
      if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(eve.target.value)) {
        this.$Message({
          message: "图片类型要求: jpeg、jpg、png!",
          type: "error"
        });
        return false;
      }
      // 转化为blob
      const reader = new FileReader();
      reader.onload = eve => {
        let data;
        if (typeof eve.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([eve.target.result]));
        } else {
          data = eve.target.result;
        }
        this.option.img = data;
        // console.log("this.option.img", this.option.img);
      };
      // 转化为base64
      reader.readAsDataURL(file);
    },
    // 上传图片
    submitFun() {
      // 获取截图的blob数据
      this.$refs.cropper.getCropBlob(blob => {
        this.updatePhoto(blob);
      });
    },
    async updatePhoto(blob) {
      try {
          // 将裁剪图片上传至后台
        const formData = new FormData();
        formData.append("file", blob, ".png");
        this.buttonLoading = true;
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open('POST', this.$baseUrl + "/api/file/update.do");
        xhr.setRequestHeader("Token", getCookieForRoleTag());
        xhr.onload = ()=> {
          var json;
          if (xhr.status != 200) {
            this.$message({ type: "warning",message: "上传失败！"});
            return;
          }
          json = JSON.parse(xhr.responseText);
          if (!json || typeof json.data.url != 'string') {
            this.$message({ type: "warning",message: "上传失败！"});
            return;
          }
          if (json.code == 0){
              // this.$message({ type: "success",message: "上传成功！"});
              // console.log(json.data.url); //上传成功后的地址 json.data.url
              this.$emit("retUrl",json.data.url);
              this.buttonLoading = false;
              this.modal = false;
          }else {
            this.$message({ type: "warning",message: json.msg});
          }
        };
        xhr.send(formData);
      } catch (error) {
        this.buttonLoading = false;
        console.log("接口报错:", error);
      }
    },
    getBase64(url, callback) {
        fetch(url).then(response => response.blob()).then(blob => {
            let reader = new FileReader();
            reader.onload = e => callback(e.target.result);
            reader.readAsDataURL(blob);
        });
    },
    // blob 转 base64
    blobToDataURI(blob, callback) {
      var reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = function (e) {
        callback(e.target.result);
      };
    }
  }
};
</script>

<style scoped lang="less">
.cropper_content {
    width: 80%;
    margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  .cropper_box {
    width: 49.5%;
    .cropper_styl {
      width: 100%;
      height: 500px;
    }
    .scope_btn {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      margin-top: 10px;
      .up_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        outline: none;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        -webkit-appearance: none;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        -webkit-transition: 0.1s;
        transition: 0.1s;
        font-weight: 500;
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
      }
    }
  }
  .handle_cropper {
    width: 49.5%;
    .show_preview {
      width: 100%;
      height: 500px;
      overflow: hidden;
      border: 1px dashed #999999;
      background-color: #f7f7f7;
      display: flex;
      justify-content: center;
      align-items: center;
      .preview {
        overflow: hidden;
        // border: 1px solid #ccc;
        background: #fff;
        box-sizing: border-box;
      }
    }
    .upload_btn {
      flex: 1;
      -webkit-flex: 1;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      margin-top: 10px;
    }
  }
}
</style>Ï



// WEBPACK FOOTER //
// src/components/cropper/index.vue